import React, { useContext, useState, memo, useEffect } from 'react'; 
import { Offcanvas } from 'react-bootstrap';
import { SocketContext, UserContext } from '../context/UserContext';


const NewCard = memo(({ seat, leaveSeat }) => {
  // console.log("Component Render", seat)
  const [seatUser, setSeatUser] = useState(null)

  const [showActionModel, setShowActionModel] = useState(false);
  const { globalUser } = useContext(UserContext);
  const { socket } = useContext(SocketContext)
  const [isMuted, setIsMuted] = useState(false);

  const removeUserFromSeat = (userid) => {
    setShowActionModel(false)
    leaveSeat(userid)
  }

  useEffect(()=>{
    if(seat && seat?.UserID !==0){
      // console.log("Seat", seat)
      setSeatUser(findUserById(seat?.UserID))
      setIsMuted(true)
    }else{
      setSeatUser(null)
    }
  },[seat])

  const findUserById = (userId) => {
    // Get live members from localStorage
    const storedMembers = localStorage.getItem("liveMembers");
    if (storedMembers) {
        // Parse the JSON string to an array
        const membersArray = JSON.parse(storedMembers);
        // Find the user by ID
        const user = membersArray.find(member => member.UserID === userId); // Assuming each member has an `id` field
        // console.log("User", user)
        return user || null; // Return user if found, otherwise return null
    }
    return null; 
  };


  useEffect(()=>{
    socket.on("UserSpeak", handleUserSpeak);

    return () => {
      socket.off("UserSpeak")
    }
  },[socket])

  const userTimeouts = new Map(); // Store timeouts per user

  const handleUserSpeak = ({UserID}) => {

      const userDiv = document.getElementById(`cnt${UserID}`);
      if (userDiv) {
          userDiv.classList.add("speak");

          // Clear previous timeout if it exists
          if (userTimeouts.has(UserID)) {
              clearTimeout(userTimeouts.get(UserID));
          }
          // Set a new timeout to remove the class
          const timeout = setTimeout(() => {
              userDiv.classList.remove("speak");
              userTimeouts.delete(UserID); 
          }, 500);
  
          // Store the new timeout
          userTimeouts.set(UserID, timeout);
      }
      // if(UserID == seatUser?.UserID && isMuted){
      //   setIsMuted(false)
      // }
  };

  const micOff = (userid) => {
    socket.emit("mic-off", {userid})
  }
  
  // Conditional rendering for the empty seat
  if (!seatUser) {

    return (
      <div
        className="card m-auto bg-transparent mb-3 d-flex justify-content-center align-items-center"
        style={{ aspectRatio: '1 / 1' }}
      >
        <i className="bi bi-ban" style={{ fontSize: 30 }}></i>
        <p className="m-0" style={{ fontSize: 10 }}>
          Empty Seat
        </p>
      </div>
    );
  }

  // Host badge
  const hostBadge = (seatUser?.isHost == 1 && seat?.SeatNo == 1) ? (
    <div
      className="text-white bg-danger fw-bold rounded-pill px-1 ms-1 mt-1"
      style={{
        position: 'absolute',
        fontSize: 8,
        // background: 'rgba(94, 94, 94, 0.5)',
        // border: '1px solid White'
      }}
    >
      Live Host
    </div>
  ) : '';


  const optionsButton = (seatUser?.UserID === globalUser?.ID || globalUser?.isMainHost) ? (
    <div onClick={() => setShowActionModel(true)}
      className="text-dark fw-bold rounded-circle ms-1 mt-1 d-flex align-items-center justify-content-center"
      style={{
        position: 'absolute',
        right: 5,
        fontSize: 12,
        background: 'white',
        cursor: 'pointer',
        width:20,
        height:20
      }}
    >
      <i className="bi bi-three-dots-vertical"></i>
    </div>
  ):('');

  // User's profile picture or default avatar
  const profileImage = seatUser?.ProfilePhoto
    ? `data:image/jpeg;base64,${seatUser.ProfilePhoto}`
    : 'https://www.shutterstock.com/image-vector/default-avatar-profile-icon-vector-600nw-1725655669.jpg';

  return (
    <>
      <div
        id={`cnt${seatUser?.UserID}`}
        className={`card m-auto mb-3 `} 
        style={{ aspectRatio: '1 / 1', position: 'relative', opacity : (!seat?.ProducerID && seat?.UserID != globalUser?.ID) ? .5 : 1}}
      >
        {hostBadge}
        {optionsButton}
        <img
          className="img-fluid rounded"
          style={{ aspectRatio: '1 / 1' }}
          src={profileImage}
          alt="Profile"
        />
        <div
          style={{
            position: 'absolute',
            bottom: 2,
            left:1,
            width: '100%',
            display:'flex',
            justifyContent:'center',
            alignItems:'center'
          }}
        >
          {/* Producer name */}
          <div
            style={{
              fontSize: 14,
              fontWeight:700,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              color:'#333',
              background: 'rgba(255, 255, 255, .5)',
              borderRadius : 3,
              // WebkitTextStroke: "0.5px white",
              // textShadow:
              // '1px 0 black, -1px 0 black, 0 1px black, 0 -1px black',
            }}
            className="w-100 text-center mx-1"
            >
            {seatUser?.FirstName}
          </div>
          {/* <div
            className={`text-white pe-1`}
            style={{ fontSize: 14 }}
            onClick={() => setIsMuted(!isMuted)} 
          >
            <i className={`bi ${isMuted ? "bi-mic-mute" : "bi-mic"}`}></i>
          </div> */}
        </div>
      </div>


      <Offcanvas className='rounded-top h-auto' show={showActionModel} onHide={() => setShowActionModel(false)} placement="bottom">
        <Offcanvas.Header className=' border-bottom'>
          <Offcanvas.Title className='text-center w-100'>Options</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        {(seatUser?.UserID === globalUser?.ID && !globalUser?.isMainHost) ? (
          <>
            <button onClick={() => removeUserFromSeat(seatUser?.UserID)} className='btn btn-outline-danger w-100 mb-1 shadow-none btn-sm'>
              <i className="bi bi-ban me-2 text-danger"></i>Leave Seat
            </button>
          </>
        ) : (seatUser?.UserID !== globalUser?.ID && globalUser?.isMainHost)? (
          <>
           <button onClick={() => removeUserFromSeat(seatUser?.UserID)} className='btn btn-outline-danger mb-1 me-2 shadow-none btn-sm'>
              <i className="bi bi-ban me-2 text-danger"></i>Remove From Seat
            </button>
            <button onClick={() => micOff(seatUser?.UserID)} className='btn btn-outline-danger mb-1 shadow-none btn-sm'>
              <i className="bi bi-mic-mute me-2 text-danger"></i>Mute Mic
            </button>
          </>
        ) : (<div>No Action</div>)}
        </Offcanvas.Body>
      </Offcanvas>
     
    </>
  );
});

export default NewCard;
